 export const gENHoverTips = {
  "zoomout": "Zoom out",
  "zoomin": "Zoom in",
  "closepanel": "Close panels",
  "exitimportwiz": "Exit import wizard",
  "exitquicklink": "Exit quick links",
  "nexttopic": "Next topic",
  "prevtopic": "Previous topic",
  "boxwidthplus": "Increase box width",
  "boxwidthminus": "Decrease box width",
  "minwidthplus": "Increase min width",
  "minwidthminus": "Decrease min width",
  "maxwidthplus": "Increase max width",
  "maxwidthminus": "Decrease max width",
  "gutterplus": "Increase gutter width",
  "gutterminus": "Decrease gutter width",
  "boxheightminus": "Decrease box height",
  "boxheightplus": "Increase box height",
  "resetboxheight": "Reset box height",
  "Reopen position multi": "Reopen position(s)",
  "spacingplus": "Increase spacing",
  "spacingminus": "Decrease spacing",
  "resetspacing": "Reset spacing to default",
  "resetmargin": "Reset margin to default",
  "marginplus": "Increase margin",
  "marginminus": "Decrease margin",
  "reviewchart": "Report issue",
  "inc10": "Increment by 10",
  "alignobjleft": "Align objects left",
  "alignobjcenter": "Align objects center",
  "alignobjright": "Align objects right",
  "alignobjtop": "Align objects top",
  "alignobjmiddle": "Align objects middle",
  "alignobjbottom": "Align objects bottom",
  "bringfront": "Bring object to front^Bring the selected object in front of all other objects.",
  "sendtoback": "Send object to back^Send the selected object behind all other objects.",
  "bringforward": "Bring object forward one place.",
  "sendback": "Send object back one place.",
  "onept": "1 pt",
  "twopt": "2 pt",
  "Profile": "Modify profile fields",
  "Subcharts & Shortcuts": "Modify subcharts & shortcuts",
  "searchHotLink": "Modify search & directory",
  "Search & Directory": "Modify directory Keys and result fields",
  "Publish": "Modify publish section",
  "backgroundHotLink": "Modify backgrounds available",
  "Presentation": "Modify views/levels/background",
  "Chart Management": "Modify charts list",
  "threept": "3 pt",
  "fourpt": "4 pt",
  "noborder": "No border",
  "singleborder": "Single border",
  "dblborder": "Double border",
  "rectangle": "Rectangle",
  "roundrect": "Round rectangle",
  "snipcornerrect": "Snip corner rectangle",
  "roundcornerrect": "Round corner rectangle",
  "tree": "Tree",
  "twocolumn": "Two column",
  "fourcolumn": "Four column",
  "sixcolumn": "Six column",
  "eightcolumn": "Eight column",
  "onecolumncenterright": "One column center right",
  "onecolumncenterleft": "One column center left",
  "onecolumnright": "One column right",
  "onecolumnleft": "One column left",
  "assistantpeerright": "Assistant peer right",
  "assistantpeerleft": "Assistant peer left",
  "assistantright": "Assistant right",
  "assistantleft": "Assistant left",
  "twelvecolumn": "Twelve column",
  "sixteencolumn": "Sixteen column",
  "twentycolumn": "Twenty column",
  "selectallboxes": "Select all boxes^Select all boxes on the page.",
  "selectallmgr":"Select all managers^Select all managers on the page. A manager must have one or more subordinate boxes.",
  "selectallassist": "Select all assistants^Select all boxes with an assistant branch style.",
  "selectallnonmgr":"Select all non-managers^Select all non-managers on the page. A non-manager has no subordinate boxes.",
  "selectalllines": "Select all connecting lines.",
  "selectpeers": "Select peers^Select all boxes that have the same manager as the selected box.",
  "selectlevel": "Select level^Select all boxes on the same level as the selected box.",
  "addprofilefield": "Add row^Add a field, formula or header to the profile.",
  "delprofilefield": "Remove row^Remove selected rows from the profile.",
  "profileup": "Reorder up^Move the selected row up one place.",
  "profiledown": "Reorder down^Move the selected row down one place.",
  "optimizepage": "Optimize branch styles^Optimize branch styles to best use available space",
  "grouping": "Grouping^Group subordinates or co-managers.",
  "grouppeer": "Create group^Create a container with selected boxes.",
  "filterAlwaysOn": "Toggle default filter state^Apply this filter when the chart is opened.",
  "highlightAlwaysOn":"Toggle default highlight state^Apply this highlight when the chart is opened.",
  "filterHidden": "Hide filter^Hide the ability to toggle this filter on/off.",
  "highlightHidden": "Hide highlight^Hide the ability to toggle this highlight on/off.",
  "ungrouppeer": "Ungroup^Remove selected boxes from their containers. New subcharts may be inserted if you have subchart breaks on the selected group.",
  "groupheader": "Create group with header^Create a container with selected boxes with a title in the header area.",
  "groupcomgr": "Group co-managers^Create a container with selected boxes with a co-manager style.",
  "groupprops": "Set group type or group columns",
  "selectbranch": "Select all boxes in branch^Select all boxes subordinate to the selected box.",
  "selectsameformat": "Select boxes w/ same format^Formats must match exactly with the selected box.",
  "selectsimilarformat":"Select boxes w/ similar format^Box width and text justification are ignored when matching formats.",
  "selectalltextboxes": "Select all text boxes.",
  "AddGroup": "Add new access group",
  "selectalllockedboxes": "Select all locked boxes.",
  "reloadtemplates": "Reload shared views^All users in an account share a common library of chart views. Reload to get the latest library.",
  "reloadusertemplates": "Reload user views^Your personal views can only be seen by you. Reload to discard your changes to your user views.",
  "saveusertemplates": "Save user views^Save your changes to your personal view library. Use reload if you want to discard any unsaved changes.",
  "edittemplate": "Edit chart view^Edit the selected chart view.",
  "addcharttemplate": "Add chart view^Add a new chart view.",
  "deletetemplate": "Delete chart views^Delete the selected chart views(s).",
  "duplicatetemplate": "Duplicate chart view^Create a copy of the selected chart view.",
  "renametemplate": "Rename chart view^Rename the selected chart view.",
  "reordertemplateup": "Reorder up^Move the selected chart view up one place.",
  "reordertemplatedown": "Reorder down^Move the selected chart view down one place.",
  "savetemplates":"Save shared views^Save any changes made to the chart view library. Use reload if you want to discard any unsaved changes.",
  "copytemplate":"Copy chart view^Copy the selected chart view from the system views to the shared views. User views can be modified. System views cannot be modified.",
  "reloadbs":"Reload shared styles^All users in an account share a common library of branch styles. Reload to get the latest library",
  "addbs": "Add box style^To add a box style, select a box in the chart and then click on this icon",
  "editbs": "Edit box style^Edit the selected box style",
  "reloauserdbs":"Reload user styles^Your personal box styles can only be seen by you. Reload to get the discard your changes",
  "saveuserbs": "Save user styles^Save changes made to the your personal box style library. Use Reload if you want to discard any unsaved changes",
  "replacebs":"Replace box style^To replace a box style, select a box in the chart, select the box style you want to replace and then click on this icon",
  "deletebs": "Delete box style^Delete the selected box style(s)",
  "duplicatebs": "Duplicate box style^Create a copy of the selected box style",
  "renamebs": "Rename box style^Rename the selected box style",
  "reorderbsup": "Reorder up^Move the selected box style up one place",
  "mfaRequired1":"You must enable MFA on your personal user profile before enabling MFA for all users in your account",
  "reorderbsdown": "Reorder down^Move the selected box style down one place",
  "savebs":"Save shared styles^Save any changes made to the shared box style library. Use reload if you want to discard any unsaved changes",
  "launchhelp": "Open the help docs^Opens a new browser tab to the OCN help docs.",
  "gotohelp": "Go to help docs",
  "copyboxstyle":"Copy box style^Copy the selected box style from the System Styles to the User Styles. User Styles can be modified. System Styles cannot be modified.",
  "parkingdrillup":"Up one level^Navigate up one level in the hierarchy. To navigate down one level, double click on an orphan.",
  "deleteorphan": "Delete Orphan^Delete the selected orphans (and all their subordinates).",
  "deletefile":"Delete file^Delete selected files. Deleted files can be recovered from the Trash folder. Deleting a file from the Trash folder will permanently delete the file.",
  "duplicatefile": "Duplicate file^Duplicate selected files.",
  "renamefile": "Rename file^Rename the selected file.",
  "deletefolder":"Delete folder^Delete the selected folder. A folder must be empty before it can be deleted (drag files to another folder or delete the files).",
  "addfolder": "Add folder^Add a new folder to your cloud storage account.",
  "renamefolder": "Rename folder^Rename the selected folder.",
  "openfile": "Open chart^Open the selected document.",
  "savefile": "Save chart^Save the current document to cloud storage.",
  "savemasterfile": "Save background^Save the current background to cloud storage.",
  "selectmasterfile": "Select background^Select a Background to apply to the current chart.",
  "unzipfile": "Unzip^Decompress zip file into the current directory.",
  "processfile": "Tools^Tools for processing files and directories.",
  "addview": "Add view^Views allow users to quickly switch to different chart presentations.",
  "deleteview": "Delete views^Delete the selected view(s).",
  "reorderviewup": "Reorder up^Move the selected view up one place.",
  "reorderviewdown": "Reorder down^Move the selected view down one place.",
  "uploadmgr":"File manager^The file manager is used to upload and download files to/from your account.",
  "selectimportfile":"Select import file^Import the selected file. The file will be used to automatically build an org chart.",
  "selectimagefile": "Select image file",
  "comparecurfile": "Select comparison file",
  "uploadfile": "Upload file^Upload a file (to cloud storage) from your computer.",
  "downloadfile": "Download file^Download a file (from cloud storage) to your computer.",
  "exitfilemgr": "Exit file manager",
  "exituploadmgr": "Exit mile manager",
  "backhelp": "Back",
  "forwardhelp": "Forward",
  "paste": "Paste (Ctrl + V)^Paste the contents of the clipboard.",
  "cut": "Cut (Ctrl + X)^Cut the selection from the document and move it to the clipboard.",
  "copyformat":"Copy format^Copy the format of the selected box to the clipboard. To apply format to other boxes, select the boxes and then select paste.",
  "copy": "Copy (Ctrl + C)^Copy the selection from the document and move it to the clipboard.",
  "boxshape": "Box shape^Change the shape of selected boxes",
  "boxfillcolor": "Box fill color^Change the fill color of selected boxes",
  "boxshadow": "Box shadow^Turn on/off shadow for selected boxes",
  "boxweight": "Border weight^Change border thickness for selected boxes",
  "boxborder": "Box border^Change border style for selected boxes",
  "boxbordercolor": "Box border color^Change the border color for selected boxes",
  "boxlayout":"Box layout^Update how a box is presented in the chart (fields displayed, box size, box shape, shadow, fonts, colors, text alignment, etc)",
  "fontselector": "Font selector^Change the font face",
  "fontsize": "Font size^Change the font size",
  "fontcolor": "Font color^Change the text color",
  "cellfillcolor": "Cell fill color^Change background color for selected cells",
  "Cell Fill Mode": "Cell fill mode^Change fill style for selected cells",
  "bold": "Bold^Make the selected text bold",
  "italic": "Italic^Italicize the selected text",
  "underline": "Underline^Underline the selected text",
  "labeloptions":"Label options^Set selected cells to display Value ('John Smith'), Value:Label (Name: John Smith) or Label ('Name').",
  "wraptext": "Wrap text^Make all content in selected cells visible by displaying on multiple lines",
  "linecolor": "Connecting line color^Set the color of selected connecting line groups.",
  "linecolor2": "Connecting line color^Set the color of subordinate connecting line group.",
  "chartrec": "Show in chart^Show the selected record in the org chart.",
  "exportdir": "Export to Excel^Create an Excel spreadsheet from the search results.",
  "dirmode": "Search^Search employee directory.",
  "linepattern": "Line style^Set line style for line subgroups.",
  "triflag": "Add highlight^Add a triangle highlight.",
  "copysection": "Copy^Copy details to clipboard.",
  "linethickness":"Line style^Set the thickness and style of selected connecting line groups and subgroups.",
  "branchstyles":"Branch styles^Change how boxes are stacked/positioned within a chart. Assistant and standard subordinate branch styles are available",
  "boxspacing":"Box spacing^Adjust the spacing between selected chart boxes. To change spacing, select the entire chart or any subset of the chart and then select one of the spacing options (Standard, Dense or Manual).",
  "boxsort": "Box sorting^Sort the selected boxes",
  "centercharthorz": "Center chart horizontally",
  "centerchartvert": "Center chart vertically",
  "aligncharttop": "Align chart top",
  "find": "Find^Search for a string.",
  "replace": "Replace^Replace a string with another string ('Manager' with 'Mgr')",
  "delete": "Delete^Delete selected object(s).",
  "DeleteAppendData": "Remove append data.",
  "DeleteMergeData": "Remove merge data.",
  "AddAppendData": "Add append data.",
  "AddMergeData": "Add merge data.",
  "fastselect": "Fast select^Select boxes that share a common attribute.",
  "arrange": "Arrange^Arrange objects on the page by adjusting their order and position",
  "pinobj":"Pin object^Pin object on the page so that it is automatically repositioned when the page is resized",
  "launch": "Auto launch^Set document to automatically open after login.",
  "accessprivs": "Access privileges^Restrict access on a per user basis.",
  "pageprops": "Page properties^Modify page size, orientation and margins",
  "fieldmgr":"Field manager^Add, delete or rename fields. Use the box layout editor to change which fields are displayed in a box.",
  "missingphotos": "Missing photos^Generate an Excel report detailing all missing photos.",
  "comparechart":"Compare charts^Generate an Excel report comparing the current chart to another chart.",
  "insertrowabove": "Insert row above",
  "insertcolleft": "Insert column left",
  "deleterows": "Delete rows",
  "insertrowbelow": "Insert row below",
  "insertcolright": "Insert column right",
  "deletecols": "Delete columns",
  "mergecells": "Merge cells",
  "unmergecells": "Unmerge cells",
  "cellbordercolor": "Cell border color",
  "cellborderthickness": "Cell border thickness",
  "cellborderpattern": "Cell border pattern",
  "oklayouted": "OK^Apply box layout changes to the chart.",
  "cancellayouted": "Cancel",
  "addfield": "Add field",
  "deletefield": "Delete field",
  "renamefield": "Rename field or formula",
  "addformula": "Add formula",
  "editformula": "Edit formula",
  "copyformula": "Copy formula",
  "adduser": "Add new user",
  "updateuser": "Update user record",
  "deleteuser": "Delete users",
  "deletesingleuser": "Delete user",
  "exportusers": "Export users^Export users to Excel file.",
  "reloadusers": "Reload users^Reload user from userfeed file",
  "exitusermgr": "Exit user manager",
  "exitdirectory": "Exit directory",
  "addgroup": "Add access group",
  "renamegroup": "Edit access group",
  "deletegroup": "Delete access group",
  "copygroup": "Copy access group",
  "addfoldergroup": "Add folder to group",
  "rmvfoldergroup": "Remove folder from group",
  "togglefolderlock": "Lock/Unlock folder^Locked folders can only be modified by an administrator.",
  "okgroupmgr": "OK^Save changes and exit.",
  "savegroupmgr": "Save^Save changes.",
  "cnclgroupmgr": "Cancel^Discard changes.",
  "emailrequired": "An email address is required to use this feature.",
  "reqpithover": "Email OCN requesting further information about point in time charts",
  "autodeltaopt": "Receive automated emails upon data source refresh detailing changes.",
  "autoarchive": "Automatically create chart archive with the frequency specified below",
  "okfieldmgr": "OK^Change field definitions.",
  "cancelfieldmgr": "Cancel",
  "okpageprop": "OK^Update page properties",
  "cancelpageprop": "Cancel",
  "downloadsvg":"Download SVG file^This format works best for inclusion in web pages. Scalable Vector Graphics (SVG) files are not supported by Microsoft Office.",
  "downloadpng":"Download PNG file^This format works well in Microsoft Office (or similiar) documents and web pages. Print quality is not as good as PDF or SVG.",
  "downloadhipng":"Download high quality PNG file^Better quality than standard PNG but file size is 4X larger. Good format for inclusion in Microsoft Word or PowerPoint documents.",
  "downloadjpg":"Download JPG file^This format is included for completeness. JPG is better for pictures than org charts.",
  "downloadxml":"Download XML file^XML files can be used by developers that want render charts using proprietary code or 3rd party tools.",
  "downloadpdf":"Download PDF file^PDF files have excellent quality both for print and on screen display.",
  "transpng": "Background transparency^Turn on/off transparent background. Recommended for PowerPoint documents. Only applicable to PNG and SVG.",
  "downloadppt": "Download PPTX file^PPTX files can be modified and rearranged with ease.",
  "exitpub": "Exit Publisher",
  "quicklinks": "Quick links^The Quick Links Panel contains shortcuts to commonly used functions.",
  "adphome": "ADP free trial^Click here to get started.",
  "editmode": "Edit mode^Use this mode if you need access to all chart editing tools.",
  "reviewmode": "Browse mode^Use this mode to review your org charts. Most editing tools are hidden.",
  "maketop":"Make top^Display selected box at the top of the current page. Insert a subchart break if necessary.",
  "newdoc": "New chart^Create a blank org chart.",
  "createmasterchart": "New master chart^Create a new master chart.",
  "configureviewerchart": "Configure chart",
  "importwiz": "Import wizard^Automatically create an org chart from external data.",
  "querydata": "Chart builder^Automatically create an org chart using a database query.",
  "configureDB":"Configure database^Change the way you access and use your data in Viewer and Builder.",
  "svrchart": "My chart^Org chart created from your organization's HR data.",
  "okquerybuilder": "Go^Create chart based on the specified query.",
  "cnclquerybuilder": "Cancel^Exit chart builder.",
  "savedoc": "Save chart^Save the current document.",
  "saveas": "Save as...^Save a copy of the current document.",
  "opendoc": "Open chart^Select a document to open.",
  "closedoc": "Close chart^Close the current document.",
  "undo": "Undo^Undo the last action.",
  "redo": "Redo^Redo last 'undo' action.",
  "exportexcel":"Export To Excel^Create an Excel spreadsheet from the current chart (each row in the spreadsheet corresponds to a box in the chart).",
  "pubdoc":"Export document^Create PDF documents, PPT documents, or PNG, SVG, or JPG images from the current chart.",
  "pubweb":"Publish to web^Create a URL that can be used to access your chart (paste into an email or link from a website).",
  "changepass": "Change password",
  "signout": "Sign out",
  "exitportal": "Exit portal mode",
  "enterportal": "Enter viewer mode",
  "about": "About",
  "showpanels":"Show panels^Display the side panel (access help, box style, chart view and parking panels).",
  "help": "Help",
  "Topics": "Topics^Search the quick reference guide.",
  "howto": "How To^Review 'How To' articles on various topics.",
  "downloadsampledata":"Download sample data^Download an Excel spreadsheet containing sample data. This is the format required by the import wizard.",
  "reviewtuts": "Tutorials^Access step by step tutorials.",
  "reviewsamples": "Review samples^Display a directory of sample files. Double click on any file to open.",
  "reviewvids": "Videos^Watch 'how to' videos.",
  "onlinedocs": "Online documentation^Detailed documentation on specific topics.",
  "downloadgetstart": "OrgChart guide^Comprehensive product help.",
  "commalerting": "Alerts^Turn on/off email notifications.",
  "releasingnotes": "Release notes^View product release notes.",
  "newslettering": "News^Review the latest updates from the OrgChart team.",
  "addsortlevel": "Add level",
  "deletesortlevel": "Delete level",
  "reordersortup": "Move up",
  "reordersortdown": "Move down",
  "uploaddata":"Upload Excel file^Upload an Excel spreadsheet containing your data. Once uploaded, you can use the import wizard to automatically create a chart.",
  "selecttool": "Select^Click to select a box. Shift+click to extend the selection. Click and drag to create a rectangular selection area.",
  "pantool":"Pan^If the whole chart cannot be displayed in the browser window, click and drag to change the displayed subarea of the chart.",
  "moveobj":"Move object^Click and drag on an object (for example, a chart or text box) to reposition on the page.",
  "addnewcharttool":"Add new chart^Add a new chart by clicking anywhere on the page. Multiple charts can be included on a single page.",
  "moveboxtool":"Move branch or box^Click and drag a box to reposition it next to its peers or underneath a new branch. The green silhouette indicates a valid move",
  "addsubtool": "Add subordinate box^Click on any box to add a subordinate",
  "addassisttool": "Add assistant box^Click on any box to add an assistant",
  "unlinktool":"Unlink branch or box^Click on a box to unlink the box (and its subordinates) from a chart. The unlinked branch (or box) becomes an independant chart on the page. The branch can be relinked to a chart using the 'Move Branch or Box' tool.",
  "addtextboxtool": "Add text box^Click on the page to add a text box.",
  "addimagetool": "Add image^Insert a picture from a file. Make sure to upload all images before using this tool.",
  "addtabletool": "Add table^Click on the page to add a table.",
  "addEnumeratedTableTool": "Add table^Click on the page to add a table.",
  "addlegendtool": "Add legend^Click on the page to add a legend.",
  "selecttoolL": "Select^Click to select a cell. Shift+click to extend the selection.",
  "pantoolL":"Pan^If the entire layout cannot be displayed in your browser window, click and drag to change the displayed subarea.",
  "marqueetoolL":"Marquee^Click and drag to define a rectangular area. All cells within the area will be selected when you release the mouse button.",
  "aligntextleft": "Align text left^Align text to the left.",
  "aligntextright": "Align text right^Align text to the right.",
  "centertext": "Center text^Center text.",
  "justifytext":"Justify^Align text to both the left and right margins. Use this option if both the label and value are shown within a cell.",
  "toptextalign": "Top align^Align text to the top.",
  "middletextalign": "Middle align^Align text to the middle.",
  "bottomtextalign": "Bottom align^Align text to the bottom.",
  "renametemplatecte": "Rename chart view^Rename the chart view.",
  "addctrule":"Add rule^Define a new rule. When a view is applied to a chart, 'rules' are used to determine how each box is formatted.",
  "editctrule": "Edit rule^Edit an existing rule.",
  "deletectrule": "Delete rule^Delete the selected rule(s).",
  "coptctrule": "Copy rule^Copy the selected rule(s).",
  "shuffleuprule": "Reorder up^Move the selected rule up one place.",
  "shuffledownrule": "Reorder down^Move the selected rule down one place.",
  "applycte":"Apply chart view^Update the chart view library and then apply the view to the current chart.",
  "okcte": "OK^Update the Chart View library.",
  "cancelcte": "Cancel",
  "Black": "Black",
  "Gray50": "Gray-50%",
  "Gray25": "Gray-25%",
  "Gray15": "Gray-15%",
  "Gray5": "Gray-5%",
  "White": "White",
  "Indigo": "Indigo",
  "Blue": "Blue",
  "Teal": "Teal",
  "Turquoise": "Turquoise",
  "Magenta": "Magenta",
  "LightTurquoise": "Light Turquoise",
  "BlueStrongAccent": "Blue Strong Accent",
  "BlueAccent": "Blue Accent",
  "BlueAccentLight": "Blue Accent Light",
  "Brown": "Brown",
  "Purple": "Purple",
  "Lavender": "Lavender",
  "Bluegray": "Blue-gray",
  "BluegrayAccent": "Blue-gray Accent",
  "BluegrayAccentLight": "Blue-gray Accent Light",
  "Rose": "Rose",
  "Green": "Green",
  "Lime": "Lime",
  "GreenStrongAccent": "Green Strong Accent",
  "GreenAccent": "Green Accent",
  "GreenAccentLight": "Green Accent Light",
  "Yellow": "Yellow",
  "Gold": "Gold",
  "GoldStrongAccent": "Gold Strong Accent",
  "GoldAccent": "Gold Accent",
  "GoldLightAccent": "Gold Light Accent",
  "LightYellow": "Light Yellow",
  "DarkRed": "Dark Red",
  "Red": "Red",
  "Orange": "Orange",
  "OrangeStrongAccent": "Orange Strong Accent",
  "OrangeAccent": "Orange Accent",
  "OrangeLightAccent": "Orange Light Accent",
  "Custom1": "Custom1",
  "Custom2": "Custom2",
  "Custom3": "Custom3",
  "Custom4": "Custom4",
  "Custom5": "Custom5",
  "Custom6": "Custom6",
  "Blue Gray": "Blue Gray",
  "Red on Gray Blue": "Red on Gray Blue",
  "White on Blue": "White on Blue",
  "Orange on Black": "Orange on Black",
  "Red on Light Gray": "Red on Light Gray",
  "White on Red": "White on Red",
  "Yellow on Blue": "Yellow on Blue",
  "White on Forest Green": "White on Forest Green",
  "Magenta on Black": "Magenta on Black",
  "Dark Gray": "Dark Gray",
  "Light Gray": "Light Gray",
  "Dark Red": "Dark Red",
  "Forest Green": "Forest Green",
  "outputoptions": "Output options^Specify where to output published documents (download or save to folder).",
  "pinLeftTop": "Pin Top, Left",
  "pinCenterTop": "Pin Top, Center",
  "pinRightTop": "Pin Top, Right",
  "pinLeftBottom": "Pin Bottom, Left",
  "pinCenterBottom": "Pin Bottom, Center",
  "pinRightBottom": "Pin Bottom, Right",
  "resetcharts": "Blank^No viewer charts.",
  "restorecharts": "Default^Default viewer chart.",
  "resetdirs": "Reset folders^Delete all folder contents.",
  "pinOff": "Turn Pinning Off",
  "pinOptions":"Positioning^Set how object will be repositioned if page shrinks or expands. Only applies when pinning is turned off.",
  "scalingOptions": "Scaling^Set how object scales when page size changes or when user resizes.",
  "renamesubchart": "Rename subcharts",
  "subchartup": "Shuffle subchart up",
  "subchartdown": "Shuffle subchart down",
  "insertsubchart": "Insert subchart break^Insert a subchart break below the selected box",
  "removesubchart": "Remove subchart break^Remove the subchart break from below the selected box",
  "normalview":"Normal mode^Show all page elements. Background elements cannot be edited in this mode.",
  "masterview":"Background mode^Show only background elements. Background elements can be edited in this mode. Background elements are included on every page of the chart.",
  "datarefresh": "Data refresh^Sync to get the latest changes from the base chart",
  "refreshprops": "Refresh properties^Update parameters used to perform a data refresh.",
  "scheduler": "Refresh scheduler^Set current chart to be automatically refreshed daily or weekly.",
  "boxlocking":"Box locking^Lock the selected boxes so that manual changes to formats or content are kept after a data refresh.",
  "connectorsmgr": "Configure Connectors^Configure data source connectors.",
  "excelimport": "Import an Excel Spreadsheet or csv file",
  "bambooimport": "Import Data from BambooHR",
  "bambooconnect": "Configure BambooHR Connector",
  "workdayimport": "Import Data from Workday",
  "cornerstoneimport": "Import Data from Cornerstone",
  "workdayconnect": "Configure Workday Connector",
  "cornerstoneconnect": "Configure Cornerstone Connector",
  "customimport": "Import Data from other data sources",
  "customconnect": "Configure Custom Connector",
  "peoplehrimport": "Import Data from PeopleHR",
  "peoplehrconnect": "Configure PeopleHR Connector",
  "ultiproimport": "Import Data from UKG Pro",
  "ultiproconnect": "Configure UKG Pro Connector",
  "adpimport": "Import Data from ADP Now",
  "adpconnect": "Configure ADP Connector",
  "subscribehrimport": "Import Data from Subscribe-HR",
  "subscribehrconnect": "Configure Subscribe-HR Connector",
  "odbcimport": "Import Data via ODBC",
  "odbcconnect": "Configure ODBC Connector",
  "sqlserverimport": "Import Data from SQL Server",
  "sqlserverconnect": "Configure SQL Server Connector",
  "sutihrimport": "Import Data from SutiHR",
  "sutihrconnect": "Configure SutiHR Connector",
  "salesforceimport": "Import Data from Salesforce",
  "salesforceconnect": "Configure Salesforce Connector",
  "sagedefaultquerystring": "Reset Query field to the default query",
  "breathehrimport": "Import Data from breatheHR",
  "breathehrconnect": "Configure breatheHR Connector",
  "successfactorsimport": "Import Data from SuccessFactors",
  "successfactorsconnect": "Configure SuccessFactors Connector",
  "googledirimport": "Import Data from Google Directory",
  "googledirconnect": "Configure Google Directory Connector",
  "trinetimport": "Import Data from TriNet",
  "trinetconnect": "Configure TriNet Connector",
  "orangeimport": "Import Data from OrangeHRM",
  "orangeconnect": "Configure OrangeHRM Connector",
  "namelyimport": "Import Data from Namely",
  "namelyconnect": "Configure Namely Connector",
  "greenhouseimport": "Import Data from Greenhouse",
  "greenhouseconnect": "Configure Greenhouse Connector",
  "sapxmlimport": "Import Data from SAP XML",
  "sapxmlconnect": "Configure SAP XML Connector",
  "jobviteconnect": "Configure Jobvite Connector",
  "icimsconnect": "Configure iCIMS Connector",
  "sapimport": "Import Data from SAP RFC",
  "sapconnect": "Configure SAP RFC Connector",
  "activedirimport": "Import Data from Active Directory",
  "activedirconnect": "Configure Active Directory Connector",
  "azureconnect": "Configure Azure Connector",
  "payspaceimport": "Import using Cloud Connect",
  "payspaceconnect": "Configure Cloud Connect",
  "leverreqscheckbox": "Default is 'open' requisitions only.",
  "separatejobreqs":"Separate job requisitions^Checking this box will use the ATS connector's count in each job requisition to create multiple boxes per job requisition. For example, if count is 5, then 5 boxes will be created for that requisition.",
  "findbyface": "Show photos^Toggle to show/hide record photos in search results",
  "expandrow": "Expand row^Increase row height to fill any remaining vertical space in the box",
  "imagesize": "Size image^Set the width and height of the image frame",
  "imagemask": "Image mask^Set a mask to apply to the image",
  "config": "Administration tools^Change password or configure your account (adminstrators only)",
  "croptochart":"Crop to chart^Crop to bounds of the chart (ignore everything but the chart). Not applicable to PDF",
  "subchartwiz": "Subchart wizard^Automatically break a chart into multiple subcharts",
  "updatemaster": "Update background^Update the background by applying a background",
  "updatepubmaster":"Update publish background^ Update the background used for publishing by applying a background",
  "masterbkgrnd": "Background color^Set the background color of the background",
  "addautotext":"Add AutoText^Click on the page to add an AutoText element. AutoText elements such as page # and subchart name automatically update based on context",
  "wikihelp": "Help",
  "ShowPreview": "File preview^Show/Hide file preview",
  "RefreshDir": "Refresh folder^Refresh current directory",
  "genlinkh": "Generate link",
  "testlinkh": "Test link",
  "copylinkh": "Copy link",
  "exiturlgen": "Exit URL generator",
  "Edit PIT": "Manage archives^Search archive history.",
  "pitRequired": "Manage archives^No archives exist for the selected chart.",
  "gotovierwerhover": "Return To viewer^Switch back to OrgChart Viewer.",
  "filterpaywall": "Filters - Premium feature^Dynamically filter groups of employees (e.g. exclude contractors).",
  "viewspaywall": "Manage views - Premium Feature^Add or remove visualizations.",
  "masterpaywall":"Background - Premium feature^Add your company logo, page numbers, legends, and more.",
  "arrowpaywall":"Dynamic navigation - Premium feature^Drill up/down your PDF or PPT documents using navigation arrows.",
  "benchpaywall": "Workbench- Premium feature^Create a chart manually or by importing your data.",
  "openpaywall": "Open chart- Premium feature^Open and save your charts as needed.",
  "builderpaywall": "Chart builder- Premium feature^Slice and dice your data to dynamically create custom charts.",
  "chartpaywall": "Chart settings - Premium feature^Display additional fields, set the chart background, and filter your data.",
  "accountpaywall":"Account settings - Premium feature^Customize user interface and fonts to match your corporate look.",
  "docsettings":"Document settings^Filter your data, configure your fields, adjust refresh settings, change page properties, and configure other chart document level settings.",
  "backgroundsettings":"Background settings^Change page properties of your background like margins, page size, and more",
  "stagger": "Stagger",
  "banded": "Banded",
  "swimlane": "Swimlane",
  "ascendingsort": "Ascending sort",
  "descendingsort": "Descending sort",
  "checkpointset":"Set this checkpoint^Set as the active checkpoint. Resetting your data will reset to this checkpoint.",
  "checkpointdelete": "Delete this checkpoint. Deleted checkpoints cannot be recovered.",
  "filteredit": "Edit this filter's name and rule",
  "filterdelete": "Delete this filter",
  "filteradd": "Add a new filter",
  "viewshelp": "Manage views^Manage available views and set the chart background.",
  "profilehelp": "Manage profile^Manage available views and set the chart background.",
  "chartbuilderhelp":"Chart builder configuration^Manage search keys, views, and backgrounds available in the Chart Builder.",
  "mappinghelp": "Data field mapping^Set key data fields in OCN to fields/columns in your data",
  "photohelp": "Manage photos^Update OCN configuration to load your photos.",
  "fieldshelp": "Manage fields^Manage available fields and formulas",
  "filterhelp": "Manage filters^Edit your filters and add new ones",
  "securityhelp":"Security^Restrict your chart access or certain data to selected roles in your organization",
  "generalhelp": "General^Change launch mode, view account status, and download user activity report",
  "chartmgmthelp": "Chart management^Add, remove, edit, and shuffle the order of your charts",
  "themehelp": "Theme^Customize your interface colors, fonts, subchart arrows, and date formats",
  "grouphelp":"Access groups^Edit your access groups. Edit group settings like row level security and chart access",
  "usershelp": "Manage users^View, update, add, and delete your users",
  "uiprofileshelp": "UI profiles^Customize UI configurations",
  "sorthelp": "Sorting^Sort the boxes on your chart",
  "checkpointshelp":"Manage checkpoints^Save a snapshot of your configuration or load a prior configuration",
  "emailnoteadd": "Add email^Add an email to notify when data refresh fails",
  "emailenoteonsuccess":"Notify on success & Failure^Email notification will be sent after a successful or failed refresh",
  "emailenoterefresh":"Notify on failure^Email notification will only be sent after a failed refresh",
  "deltaemailnoteadd":"Add email^Add an email address to send a delta report to detailing changes since the last archive",
  "deltaemailnoteaddsuccess":"Notify on success^Include a delta report in a successful refresh email that details changes since the last most recent archive",
  "sortedit": "Change sort criteria",
  "cbsearchkeyedit": "Rename this search key",
  "cbsearchkeydel": "Delete this search key",
  "cbsearchkeyadd": "Add a new search key",
  "chsearchkeylookup": "Search key lookup^Enable a picker for this field instead of typing",
  "Currently Loaded": "Currently loaded",
  "Load Date": "Load date",
  "pointintimereport":"Download report^Generates an Excel report of chart changes made between the specified dates",
  "newpit":"Create new^Create a new point in time chart that can be used to track changes in your current chart",
  "masteradd": "Add to available options",
  "masterdel": "Remove from available options",
  "masterpub": "Set as publish background^This Background will be used when exporting the chart",
  "buildermaster":"Set as builder background default^This Background will be used when creating a chart using the Builder",
  "puboptionshelp": "Publish^Configure publishing settings.",
  "viewdefault": "Set as default view^This view will be applied to the chart by default",
  "invalidmap": "This field is not in your data! Please update it with a field in your data.",
  "settopbox": "Set top box^OCN automatically detects who is the top of your organization. Use this option to lookup a new top box to override the normal setting",
  "pointintime": "Enable point in time charts^Point in time charts provide saved snapshots of your charts automatically. Look up your chart from the past and compare it with another chart",
  "refreshopts": "Refresh options^Set the frequency of the data refresh and other options",
  "setdefault": "Set default^Set this chart to launch by default when entering Viewer",
  "pointintimehelp":"Point in time^Configure archive frequency. Manage archive notifications. Generate Excel delta reports",
  "subchartshortcuthelp":"Sucharts & shortcuts^Configure Subchart naming convention. Apply sort on Subcharts. Choose Subchart breaks for publishing and building. Configure Shortcut Mapping",
  "Recent Target Positions": "Recent top positions",
  "Set Top Position": "Set top box^Search for a position to build a chart on",
  "excelPlanReport": "Download an .xlsx document detailing the changes present in the Activity Log.",
  "searchhelp": "Search & directory^ Configure advanced and directory search keys",
  "fieldtypeedit": "Edit field type^Set the field type and format options",
  "fieldlabeledit": "Edit label^Set the label of this field, and translate it into different languages",
  "privatefolderaccess": "Private Folders^Create private folders for Read/Write & Admin users",
  "viewsrestrict": "Limit the views this group has access to.",
  "chartrestrict": "Allow access to this chart",
  "limitfield":"Remove field^Removes this field from all records. Changes will be applied after next chart refresh",
  "exportexcelrestrict": "Allow excel output of charts",
  "edittempsrestrict": "Allow edits to'+'chart views and box styles",
  "branchrestrict": "Activate branch level security for this chart",
  "needswitchchart": "You must load the selected chart to edit filters",
  "advancedSettings": "Configure access group.",
  "edituser": "Edit user",
  "renameview": "Rename this view.",
  "importformula": "Import formula",
  "allowedFolderList": "Allowed folders^Toggle ON to lock",
  "addAGFolder": "Add a folder.",
  "removeAGFolder": "Remove a folder.",
  "setrole": "Activates role assignment",
  "setrowsec": "Activates row level security",
  "setPIT": "Activates point in time",
  "roleSetting": "Role assignment^Assign a seat type",
  "rowprofile": "Security profile^Assign a row level security profile",
  "setgroupviews": "Allowed views^Allow views for this chart",
  "setgroupfilters": "Allowed filters^Allow filters for this chart",
  "setgrouphighlights": "Allowed highlights^Allow highlights for this chart",
  "accessChart": "Allow access to this chart",
  "branchLevelSecurityGroup": "Activate branch security for this chart",
  "chgChartPicker": "Select a chart",
  "addnewchart": "Add chart^Create a new dynamic chart",
  "copyexistingchart": "Copy chart^Create a copy of an existing chart",
  "renamechart": "Rename chart",
  "chartup": "Shuffle chart up",
  "chartdown": "Shuffle chart down",
  "delchart": "Delete chart",
  "uiprofilesetting": "Activate UI profile",
  "uiprofileSelect": "UI profile^Assign a UI profile",
  "editConditionalField": "View field set",
  "addCustomFont": "Add font style",
  "AddFieldPickerFilter": "Field picker^Select a field",
  "AddFieldValuePickerFilter": "Add a value to the filter list",
  "DelFieldValuePickerFilter": "Remove a value from the filter list",
  "includefilteredimport": "Include filtered managers",
  "orgoptpaywall":"Entire org report - Premium feature^Generate a report of every employee in your organization, even outside this hierarchy.",
  "toporphanoptpaywall": "Top orphan report - Premium feature^Generate a report of every other branch with a reporting structure.",
  "orphanoptpaywall":"Orphan report - Premium feature^Generate a report of the orphan records in your organization.",
  "addnewuiprofile": "Add UI profile^Select to create an additional UI Profile to configure.",
  "copycurrentuiprofile":"Copy UI profile^Select to Create a duplicate of the currently selected UI profile.",
  "renameuiprofile": "Rename UI profile^Select to Rename the currently selected UI profile.",
  "rowleveloptions": "Profile options^Edit, copy, & delete profile",
  "renamerowsecprofile": "Rename security profile",
  "rowlevelconfigure": "Configure security profile",
  "rowleveldelete": "Delete security profile",
  "rowlevelcopy": "Copy security profile",
  "editdescriptionrowsecprofile": "Edit profile description",
  "rowsecaddrule": "Add new set^Add new conditional rule set.",
  "rowsecremoverule": "Remove set^Remove conditional rule set.",
  "rowsecadddef": "Add new definition^Add new definition to rule set.",
  "addrowsecfield": "Add field^Add field to rule set.",
  "removerowsecfield": "Remove field^Remove field from rule set.",
  "rowsecdefremovefieldpair": "Remove field^Remove field condition from definition.",
  "rowsecdefeditfieldpair": "Edit condition^Edit field condition.",
  "rowsecdefaddfieldpair": "Define a new field condition",
  "rowsecdefincludeself": "Enable self field identifier",
  "rowsecdefselfidedit": "Edit self field ID",
  "rowsecfieldpairaddfield": "Select field",
  "rowsecfieldpairaddvalue": "Select field value",
  "branchsecaddnewprofile": "Add new profile^Create new branch level security profile.",
  "rowsecaddnewprofile": "Add new profile^Create new row level security profile.",
  "editrowsecdefinition": "Definition options^Edit, copy, & delete definition.",
  "checkpointrename": "Rename checkpoint",
  "ManageConnectors": "Manage connectors",
  "Edit Operation": "View operation^Manage the configuration settings of this operation.",
  "Add Operation": "Add operation",
  "Add Rule":"Add rule^Rules define which boxes the operation includes in the calculation. Rules must be met for the operation to be applied.",
  "Remove Operation": "Remove operation",
  "moveoperationup": "Move up^Move the selected operation up one place.",
  "moveoperationdown": "Move down^Move the selected operation down one place.",
  "advsearchpaywall":"Advanced search - premium feature^Customize your search to lookup employees by ID, Division, or location.",
  "Remove Value": "Remove value",
  "Remove Field": "Remove field",
  "Delete Filter Group": "Delete group",
  "Add Value": "Add value",
  "Delete Rule": "Remove rule",
  "Edit Value": "Edit^Opens value in text editor.",
  "Include Self": "Include self in operation.",
  "Edit Configuration": "Edit configuration",
  "Delete Formula": "Delete formula",
  "AboutSum": "Sum operator^Returns the SUM of all field values that meet the specified criteria.",
  "AboutAverage":"Average operator^Returns the AVERAGE of all field values that meet the specified criteria.",
  "AboutCount": "Count operator^Returns the number COUNT of boxes that meet the specified criteria.",
  "AboutConcat":"Concatenate operator^Returns a CONCATENATION of all values that meet the specified criteria.",
  "AboutAdd": "Add operator^Returns the SUM of the two prior operation results.",
  "AboutSubtract": "Subtract operator^Returns the DIFFERENCE of the two prior operation results.",
  "AboutMultiply": "Multiply operator^Returns the PRODUCT of the two prior operation results.",
  "AboutDivide": "Divide operator^Returns the QUOTIENT of the two prior operation results.",
  "Linked Template": "Linked view^The selected chart view will be applied as part of this view.",
  "resettocheckpoints": "Reload charts^Reloads your charts using the selected checkpoint.",
  "downloadcheckpoint":"Download checkpoint^Download a checkpoint (from cloud storage) to your computer.",
  "uploadcheckpoint": "Upload checkpoint^Upload a checkpoint (to cloud storage) from your computer.",
  "highlightadd": "Add new highlight",
  "highlightedit": "Edit highlight",
  "highlightdel": "Delete highlight",
  "manageUIProfile": "Configure profile^Copy/Rename/Delete Selected Profile",
  "indexPage": "Index mode^Toggle index mode.",
  "selectallgroups": "Select all groups^Selects all boxes within groups",
  "selectallingroup": "Select boxes in group^Selects all other boxes in this group",
  "editfieldmap": "Edit field map.",
  "removefieldmap": "Delete field map.",
  "addHeaders": "Add field map.",
  "clearHeaders": "Clear mapping^Clears all field mappings for current selected chart.",
  "loadHeaders": "Load mapping^Auto-assigns all field mappings for current selected chart.",
  "loadmergeheaders": "Load headers from the merge source.",
  "loadappendheaders": "Load headers from the append source.",
  "addpiechart": "Add pie chart^Click on the page to add a pie chart.",
  "BrowseFile": "Browse^Search files and folders with a picker",
  "SampleFile": "Sample data^Load a sample data set to get started.",
  "bambooHelp": "What is my subdomain?^The subdomain used to access your account (If you access BambooHR at https://mycompany.bamboohr.com, then the subdomain is 'mycompany')",
  "Create Plan": "Create plan",
  "Open Plan": "Open plan",
  "Save Plan": "Save plan",
  "Delete Plan": "Delete plan",
  "Lock Plan": "Lock plan",
  "Unlock Plan": "Unlock plan",
  "Edit Plan": "Edit plan",
  "Plan Options": "Plan options",
  "Share Plan": "Share plan",
  "Change Role": "Change role",
  "Remove User": "Remove user^Stop sharing plan with this user",
  "Show Dashboard": "Show dashboard",
  "Hide Dashboard": "Hide dashboard",
  "Exit View Settings": "Exit view settings",
  "Edit Metrics": "Edit metrics",
  "Remove Metric": "Remove metric",
  "Remove Talent": "Remove talent",
  "Set Supervisor": "Set the supervisor for the new record.",
  "Expand": "Expand",
  "Collapse": "Collapse",
  "bringAuxDirectReports": "Display an Aux Employee's direct reports.",
  "Find Value": "Find Value",
  "Add Chart Document":"Add chart document^Add a chart document made from a master chart to the available charts list in Viewer.",
  "Select Date": "Select date",
  "Filter Date Range": "Filter date range^Filter values within a specified date range",
  "rowsecrulehover":"Set logical operator to determine how this Conditional Definition will be compared against others.",
  "archiveCleanup": "Delete archives older than the specified amount",
  "Edit Selected Table":"Edit table^Add, update, move, and suppress records using append entries from this table.",
  "Edit Table": "Edit table",
  "Delete Table": "Delete append table",
  "Rename Table": "Rename table",
  "View Tables": "Manage tables^Create new, update, and delete append tables",
  "New Append Table":"Create append table^Append tables can be used as an append source in your chart.",
  "Remove Table Entry":"Delete entry^Delete Selected Entry. (Changes will take effect after next chart refresh).",
  "ShowFieldHistory": "Show Field History^View all changes to this field",
  "Show plan overlay":"Show plan overlay^Show the overlays over the chart boxes indicating changes",
  "Hide plan overlay":"Hide plan overlay^Hide the overlays over the chart boxes indicating changes",
  "Remove all records from the Talent Pool": "Remove all records from the Talent Pool",
  "ContainsValueImportFilter":"Toggle Contains^When checked all records with a value containing this value will be filtered.",
  "Select a chart above to validate the user against.":"Select a chart above to validate the user against.",
  "Select a field to use in identifying a user's record on the chart.":"Select a field to use in identifying a user's record on the chart.",
  "Add a field to begin interactive filtering": "Add a field to begin interactive filtering",
  "Clear all interactive filter fields": "Clear all interactive filter fields",
  "oracleserverurl":"REST Server URL^ Typically, the URL of your Oracle Cloud service. For example, https://servername.fa.us2.oraclecloud.com.",
  "oraclecredentials":"An Oracle Cloud service user with permissions to access the resources you're using",
  "oracleExpandParam": "A comma separated list of child resources to expand for each record.",
  "oracleFinderParam":"Finders are pre-defined queries associated with a resource. You can use finders to retrieve records that match the query criteria.",
  "oracleQueryParam":"You can use operators to query resources based on string, numeric, date, and child resource attributes.",
  "newstaticdoc": "New chart^Create a manual document (not linked to your HR data)",
  "Advanced Search": "Advanced search",
  "Standard Search": "Standard search",
  "Switch Mode": "Switch mode",
  "Download a copy of this plan": "Download a copy of this plan",
  "DataAggPaywall":"Aggregating 3 or more data sources is an Enterprise feature. Contact your sales representative for more information.",
  "branchScope": "Use branch top^Data values will be derived from the top box of the current page",
  "chartScope": "Use chart top^Data values will be derived from the top box of the entire chart",
  "Copy All": "Copy all",
  "Copy Chart Info": "Copy chart info",
  "Copy Plan Info": "Copy plan info",
  "Copy Account Details": "Copy account details",
  "Copy User Details": "Copy user details",
  "Copy Application Info": "Copy application info",
  "Append Entry Help": "Add, update, move, and suppress records in your chart.",
  "About Append Tables": "Append tables allow you to change values from your source data.",
  "Edit Append Entry": "Edit append entry",
  "Delete Append Entry": "Delete append entry",
  "Filtered records will be grayed out": "Filtered records will be grayed out",
  "Filtered records will be removed": "Filtered records will be removed",
  "Toggle between showing and hiding filtered managers":"Toggle between showing and hiding filtered managers",
  "Reserved Field Name": "Reserved field name",
  "Add a new field to your chart data through the append table":"Add a new field to your chart data through the append table",
  "Enter a new field name": "Enter a new field name",
  "Perform a Data Source refresh to begin selecting unique values for this field":"Perform a data source refresh to begin selecting unique values for this field",
  "ResetLimitFields": "Reset Fields^No field restrictions (Default)",
  "Plan Build Disabled":"Cannot Build Plan From Current Chart^Open a Master Chart in Viewer before building a new plan.",
  "ukgDetailedDataPull": "Include 'Account Demographics', 'Profiles' (Compensation), and 'Badges' in the data pull. This will disable the option to perform a manual refresh.",
  "Next Page": "Next page",
  "Previous Page": "Previous page",
  "Next Page Set": "Next page set",
  "Previous Page Set": "Previous page set",
  "Refresh the source chart prior to adding this field to a table.":"Refresh the source chart prior to adding this field to a table.",
  "Show Breadcrumb":"Show breadcrumb^See the trail of records as you navigate up and down branches in your chart.",
  "Hide Breadcrumb": "Hide breadcrumb^Hides the breadcrumb trail.",
  "Chart Info": "About session^Information about your session (chart information, user details, account details, and more).",
  "Default Background":"Standard background^Creates a standard background with logo, page numbers, legend, and more.",
  "New Background": "New background^Create a new background from scratch",
  "Open Existing Background":"Open background^Open an existing background from your saved folder list",
  "Upload Append Table": "Import table^Import table data from an excel file. To generate data from a table, use the Export Table function.",
  "Export Append Table":"Export table^Download table data to excel file. This file can be used to transfer table data between accounts.",
  "Append Table Custom Fields": "Custom fields^Manage custom fields in use by your table",
  "Hot Link": "Open Configuration",
  "Custom Query": "Specify Full Query",
  "Create New Field": "Create Field^Create a standard static field or create a new formula field.",
  "missingchartview": "Missing chart view, using system default.",
  "viewmissingstyle": "Could not find box style, falling back to default.",
  "Doc Inherits from Master Chart": "Master Chart Driven^This Document inherits settings from a Master Chart. Any changes to your Master Chart settings will be reflected in this document when the document is refreshed. Please note: Some Document Settings may only be configurable at the Source Master Chart.",
  "Hide Chart Editor": "Hide Chart Editor",
  "Show Chart Editor": "Show Chart Editor",
  "Chart description": "Chart description",
  "Highlights detail": "Highlights^Tag records with colors in real time",
  "View rules": "View rules^Edit the automated rules driving your chart presentation",
  "Staging detail": "Staging^Drag and drop records to and from staging to re-arrange teams",
  "Changes detail":"Changes^Review the data, formatting, and pagination changes made to this chart",
  "Advanced Search Fields":"Advanced search fields^Add or remove search fields to customize your search criteria",
  "Rule box style": "Box style^The box style will replace all prior box formatting",
  "Rule field":"Field properties^Alter the appearance of any occurrence of theis field in the box layout",
  "Rule branch": "Branch style^Change the branch style of the chart box (can apply to peers)",
  "Rule box": "Box properties^Alter the appearance of the chart box layout",
  "Rule background":"Background^Background will be applied when the top box of the subchart matches the rule",
  "Rule link":"Link view^Linked template will be applied when the top box of the subchart matches the rule criteria",
  "Rule highlight": "Highlight^Overlay a region of color over boxes that match the criteria",
  "Rule grouping":"Grouping^Combine boxes into groups to organize them by category or reduce screen footprint",
  "Help menu": "Help^Links to the support portal and guides",
  "Background detail":"Background^Change the background or adjust the page properties for your chart",
  "Box style library": "Box style library^Manage and create box styles, which control the format of chart records",
  "Auto-sync": "Auto-sync^Automatically keep this chart up to date with the latest base chart data",
  "Refresh base": "Refresh from source^Connect to the data source of this base chart for the latest data from your HRIS or flat file",
  "Box flag": "Box flag^Configure a flag and label for the selected boxes",
  "Delete box": "Delete box^Delete the selected boxes",
  "Delete box (positions)": "Delete positions or employees^Delete the selected position or employee boxes. Deleting a position box will delete all the employees.",
  "Horizontal alignment":"Horizontal alignment^Change the horizontal alignment of text in the selected cells",
  "Vertical alignment":"Vertical alignment^Change the vertical alignment of text in the selected cells",
  "Sync plan": "Sync plan^Sync this plan with the base chart to get the latest changes",
  "Promote View":"Promote view^Make view available to end users in the available views dropdown menu",
  "Demote View": "Demote view^Remove view from the available views drop down menu",
  "Copy to Shared Library":"Copy to shared library^Create a copy of this system view in the shared library to customize it",
  "Dashboard": "Dashboard^View high level information about your plan at a glance",
  "Talent pool": "Talent pool^Reference key records inside and outside the scope of this plan",
  "Open change": "Open change",
  "View details": "View details",
  "Navigate to record in plan": "Navigate to record in plan",
  "See comment": "See comment",
  "Preview":"Preview^Preview the box formatting with your source data. The field values are taken from the top box of our chart",
  "Gutter":"Gutter^Set the amount of space between the edge of the cells within a box and the border of the box",
  "Box height": "Box height^Set the height of the box",
  "Box width": "Box width^Set the width of the box",
  "Field label": "Field label^Choose how the selected field should be displayed in the box",
  "Field selector":"Field value^Choose what value is displayed in the selected cell",
  "Copy formatting":"Copy formatting^Copy the formatting changes made to this box, in order to paste the formatting to other exiting chart boxes",
  "Create rule":"Create rule^Apply the formatting changes in this box to other records using chart rules. Chart rules are only available on this custom chart",
  "boxclear": "Clear^Undo all formatting changes",
  "Add to library":"Add to library^Add the box style to the box style library, in order to access it at anytime or use it future views",
  "Modify additional fields available in plan": "Modify additional fields available in plan",
  "Horizontal Spacing Tip":"Horizontal Spacing^Increase or decrease the horizontal space between the selected element and the nearest horizontal margin",
  "Vertical Spacing Tip":"Vertical Spacing^Increase or decrease the vertical space between the selected element and the nearest vertical margin",
  "Resize Image Tip": "Resize Image^Change the size of the selected image",
  "Grouping Detail":
    "Grouping^Combine boxes into groups to organize them by category or reduce screen footprint",
  "Row actions" : "Row actions^Insert/Delete rows",
  "Column actions": "Column actions^Insert/Delete columns",
  "Select merge type": "Select merge type",
  "Merge cells": "Merge cells",
  "addsubtoolpos": "Add subordinate positions or employees^Click on any box to add a subordinate position or employee.",
   "Auto-save": "Auto-save^Automatically save the changes made to this chart.",
  "View Functional Statement": "Functional Statement^View the functional statement for the selected organizational unit",
  "Navigate to a unit": "Navigator^Navigate to any unit in the chart"
}
